<!--  -->
<template>
  <div>
    <van-nav-bar
      :title="$t('platform.address')"
      left-arrow
      fixed
      z-index="9"
      @click-left="$router.push('/ShopSet/' + sessionStorage.actShopId)"
    >
      <van-icon
        name="./static/img/add_staff.png"
        slot="right"
        @click="$router.push('/CreatAddress')"
        style="font-size: 24px;"
      />
    </van-nav-bar>
    <div class="contentWrapper">
      <van-cell-group>
        <!-- <van-cell v-for="(item,index) in shopAddress" :key="index" :title="item.name" :value="item.price" is-link @click="editAdd(item)"/> -->
        <van-cell
          v-for="(item, index) in shopAddress"
          :key="index"
          :value="item.price"
          is-link
		  height:
        >
          <template #title>
            <span class="custom-title">{{ item.name }}</span>
			<span class="forceSwitch">{{$t('platform.ForceSurcharge')}}</span>
			<van-switch v-model="item.status" @click="ForceSwitch(item)" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shopAddress: "",
    };
  },
  created() {
    this.getShop();
  },
  methods: {
    // 获取店铺信息
    getShop() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/store/" + sessionStorage.actShopId + "/show",
      })
        .then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.shopAddress = res.data.data.additionals;
            for (let i = 0; i < this.shopAddress.length; i++) {
              if (this.shopAddress[i].status == 1) {
                this.shopAddress[i].status = true;
              } else if (this.shopAddress[i].status == 0) {
                this.shopAddress[i].status = false;
              }
            }
            console.log(this.shopAddress);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopSet.message"),
          });
        });
    },
    editAdd(item) {
      sessionStorage.setItem("addressName", item.name);
      sessionStorage.setItem("addressPrice", item.price);
      this.$router.push("/EditAddress/" + item.id);
    },
    ForceSwitch(item) {
      console.log(item.status);
      let status = 0;
      if (item.status == false) {
        status = 1;
      } else if (status == true) {
        status = 0;
      }
      console.log(status);
      this.$axios({
        method: "patch",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/additional/" + item.id + "/update",
        data: {
          name: item.name,
          price: item.price,
          status: status,
        },
      })
        .then((res) => {
          if (res.data.status == 200) {
            console.log(res);
            this.$toast({
              type: "success",
              message: res.data.message,
            });
          }else{
						for (let i in res.data.error) {
							this.$toast({
								type:'fail',
								message:res.data.error[i],
							});
						}
					}
        })
        .catch((err) => {
          this.$toast({
						type:'fail',
						message:this.$t('StaffList.message'),
					});
        });
    },
  },
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-cell {
  height: 60px;
}
/deep/ .van-switch {
  font-size: 25px;
  position: absolute;
  right: 7.5rem;
  z-index: 999;
}
.forceSwitch {
  display: inline-block;
  position: absolute;
  top: 0.9375rem;
  right: 12.5rem;
}
.contentWrapper {
  /* padding-top: 46px; */
}
.text {
  margin-top: 20px;
  font-size: 18px;
  text-align: center;
}
.NowTag {
  padding: 0.525rem;
  margin-left: 2.25rem;
}
</style>



// WEBPACK FOOTER //
// src/Address/AddressList.vue